import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const START_SECONDS = 22 * 60 + 22;
export function TopTimerBar() {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  const mm = String(Math.floor(seconds / 60)).padStart(2, '0');
  const ss = String(seconds % 60).padStart(2, '0');
  return <div role="timer" aria-label={`Offer ends in ${mm} minutes ${ss} seconds`} className="sticky top-0 z-50 w-full bg-grape-deep shadow-[0_4px_14px_-6px_rgba(7,35,26,0.5)]" data-id="element-213" data-mp="2p404m62n1rfm">
      <div className="mx-auto flex max-w-4xl items-center justify-center gap-4 px-4 py-2 sm:gap-6" style={{
      paddingBottom: "0px"
    }} data-id="element-214" data-mp="2z2646h0z2lhb">
        <HourglassIcon className="h-5 w-5 shrink-0 text-white" aria-hidden="true" data-id="element-215" data-mp="zpvd9uezvdzu" />
        <p className="text-[9px] font-bold uppercase leading-[1.9] tracking-[0.3em] text-white sm:text-[10px]" data-id="element-216" data-mp="14nn1adciqfyr">
          The offer
          <br data-id="element-217" data-mp="2d8bebzv7z39a" />
          ends in:
        </p>
        <p className="flex items-baseline gap-1.5 font-display text-white tabular-nums" data-id="element-218" data-mp="28gtddbt752ob">
          <span className="text-2xl font-black sm:text-3xl" data-id="element-219" data-mp="28f03lnnae2c3">{mm}</span>
          <span className="text-xs font-bold uppercase" data-id="element-220" data-mp="23i9nx1fe98r7">min</span>
          <span className="mx-1 text-2xl font-black text-white/60 sm:text-3xl" data-id="element-221" data-mp="1zgxxitop4jhy">:</span>
          <span className="text-2xl font-black sm:text-3xl" data-id="element-222" data-mp="2w6xgli2h30es">{ss}</span>
          <span className="text-xs font-bold uppercase" data-id="element-223" data-mp="2w41jtx2d2hrx">sec</span>
        </p>
      </div>
    </div>;
}